import firebase from "firebase/app";
import 'firebase/analytics'
import 'firebase/auth'
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAplKXxPN0ldkh3jTJ85GPpuWPKQIv9Qx0",
    authDomain: "la-llucana.firebaseapp.com",
    databaseURL: "https://la-llucana.firebaseio.com",
    projectId: "la-llucana",
    storageBucket: "la-llucana.appspot.com",
    messagingSenderId: "732614153178",
    appId: "1:732614153178:web:600d72b1d016410bc0e6e3",
    measurementId: "G-VS0SR66MLF"
};
const app = firebase.initializeApp(firebaseConfig);
firebase.analytics();
export default app;